(function () {
  const form = document.getElementById('B2BRegisterForm');
  if (!form) return;

  form.addEventListener('submit', function () {
    const vat = document.getElementById('B2BRegisterForm-vat');
    const phone = document.getElementById('B2BRegisterForm-phone');
    if (vat) sessionStorage.setItem('b2b_pending_vat', vat.value.trim());
    if (phone) sessionStorage.setItem('b2b_pending_phone', phone.value.trim());
  });
})();

(function () {
  const autoForm = document.getElementById('B2BAutoContactForm');
  if (!autoForm) return;

  const vat = sessionStorage.getItem('b2b_pending_vat');
  const phone = sessionStorage.getItem('b2b_pending_phone');
  if (!vat && !phone) return;

  const vatInput = autoForm.querySelector('[name="contact[Partita IVA]"]');
  const phoneInput = autoForm.querySelector('[name="contact[Numero di telefono]"]');
  if (vatInput && vat) vatInput.value = vat;
  if (phoneInput && phone) phoneInput.value = phone;

  sessionStorage.removeItem('b2b_pending_vat');
  sessionStorage.removeItem('b2b_pending_phone');
  autoForm.submit();
})();
